import { createFileRoute } from '@tanstack/react-router';
import { administratorApi } from '../../../../features/adminPanel/services/api/administratorApi';
import { assistantAPI } from '../../../../features/marketplace/services/api/assistantAPI';
import { administratorKeys } from '../../../../features/adminPanel/services/queries/administratorQueries';

export const Route = createFileRoute('/_app/assistant/create')({
  loader: async ({ context }) => {
    const { queryClient } = context;

    //  Assistant creation configuration
    const formConfigData = await queryClient.ensureQueryData({
      queryKey: ['assistantFormConfiguration'],
      queryFn: () => assistantAPI.getAssistantCreationConfigurationAsync(),
      staleTime: Infinity,
    });

    //  Functional Assistant Admin permission
    const isFunctionalAdmin = await queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Function Administrator'),
      queryFn: () =>
        administratorApi.getAdminParameters('Function Administrator'),
      staleTime: Infinity,
    });

    return {
      formConfigData,
      isFunctionalAdmin,
      hasAdminAccess: Boolean(isFunctionalAdmin),
    };
  },
});
